module.exports = __webpack_public_path__ + "img/big2-5.e646164d.jpg";